import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Swal from "sweetalert2";
import request from "../../Apis/request";
import { BaseURL,  uniqueToken, } from "../../api/DataApis";
import {GpsBaseURL, Role} from "../../api/DataApis";
import axios from "axios";
import Select from 'react-select';


function Add() {
  document.title = "Product | Add";
  let navigate = useNavigate();

console.log("Role:", Role);
  // State variables
  const [Title, setTitle] = useState("");
  const [selectedStatusType, setSelectedStatusType] = useState("");
  const [Price, setPrice] = useState("");
  const [Stock, setStock] = useState("");
  const [IsFeatured, setIsFeatured] =  useState("");
  const [loading, setLoading] = useState(false);
  const [Description, setDescription] =  useState("");
  const [selectedCorporate, setSelectedCorporate] = useState("");
  const [selectcategory, setselectcategory]  =  useState("");
  const [categoryData, setCategoryData] =  useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [loadings, setLoadings] = useState(false);
   const [Logo, setLogo] =  useState(null);
   const [length, setlength] = useState("");
   const [breadth, setbreadth] = useState("");
   const [height, setheight] = useState("");
   const [quantity, setquantity] = useState("");
   const [weight, setweight] = useState("");
   const [discount, setdiscount] = useState("");
   const [GST, setGST] = useState("");
   const [istoggle, setistoggle] = useState(false);
   const [ProductData, setproductData] = useState([]);
   const [selectProduct, setselectProducts] = useState([]);
  //  const [Quantity, setQuantity] = useState("");
 

  const handleTitleChange = (e) => setTitle(e.target.value);
 
  const handlePriceChange = (e) => setPrice(e.target.value);
  const handleStockChange = (e)   => setStock(e.target.value);
  const handleFeaturedChange =  (e) =>  setIsFeatured(e.target.value);
  const handleDescriptionChange =  (e) =>  setDescription(e.target.value);
  const handlecorporateChange = (selectedOption) => {
    console.log("selectedOption3wrewgfreh", selectedOption);
    if(selectedOption) {
   setSelectedCorporate( selectedOption._id );
    } else {
      setSelectedCorporate(null);
    }
  }
  const handleProductsChange = (selectedOptions) => {
    console.log("Selected Products:", selectedOptions);
  
    setselectProducts(
      Array.isArray(selectedOptions)
        ? selectedOptions.map(option => option.value) 
        : [] // Reset to empty if `selectedOptions` is not an array
    );
  };
  
  
  
  const handlecategoryChange = (selectedOption) => {
    console.log("selectedOption3wrewgfreh", selectedOption);
    if(selectedOption) {
      setselectcategory( selectedOption._id );
    } else {
      setselectcategory(null);
    }
  }
  const handleLogoChange = (e) => setLogo(e.target.files[0]);

  const fetchCorporate = async (page) => {
    
    
    // Base API URL
    let apiEndpoint = decodeURIComponent(`${GpsBaseURL}/corporate`);
   
    
  try {
      const response = await axios.get(apiEndpoint, {
        headers: {
          "Content-type": "application/json; charset=UTF-8",
          Authorization: `Bearer ${uniqueToken}`, // Replace with actual token if needed
        },
      });
  
      console.log("response", response);
  
      setFilteredData(response.data?.data);
    // Assuming API returns totalCount for pagination
    } catch (error) {
      console.error("Error fetching users:", error);
    } 
  };

 
  const fetchProducts = async () => {
    
    
    // Base API URL
    let apiEndpoint = decodeURIComponent(`${GpsBaseURL}/product/get/list?status=Active&isCombo=true`);
   
    
  try {
      const response = await axios.get(apiEndpoint, {
        headers: {
          "Content-type": "application/json; charset=UTF-8",
          Authorization: `Bearer ${uniqueToken}`, // Replace with actual token if needed
        },
      });
  
      console.log("response", response);
  
      setproductData(response.data);
    // Assuming API returns totalCount for pagination
    } catch (error) {
      console.error("Error fetching users:", error);
    } 
  };
  useEffect(() => {
    fetchProducts();
  }, []);
  const fetchCategory = async (page) => {
 
    let apiEndpoint = decodeURIComponent(`${GpsBaseURL}/master?status=Active`);
    if(selectedCorporate  || Role === "true") {
   apiEndpoint = decodeURIComponent(`${GpsBaseURL}/master?status=Active&corporate_id=${selectedCorporate}`);
    }
   
    
  try {
      const response = await axios.get(apiEndpoint, {
        headers: {
          "Content-type": "application/json; charset=UTF-8",
          Authorization: `Bearer ${uniqueToken}`, // Replace with actual token if needed
        },
      });
  
      console.log("response", response);
  
      setCategoryData(response.data?.data);
    // Assuming API returns totalCount for pagination
    } catch (error) {
      console.error("Error fetching users:", error);
    } 
  };
  useEffect(() => {
    if (selectedCorporate || Role === "true") {
      fetchCategory();
    }
  }, [selectedCorporate, Role]);
  
  // Re-fetch users whenever searchTerm changes
    useEffect(() => {
      if (Role === "false") {
        fetchCorporate();  // Only fetch corporate data if Role === "false"
      }
    }, [Role]);
    const corporateOptions = filteredData?.map(corporate => ({
      value: corporate._id,
      label: `${corporate.corporate_name} (${corporate?.email})`,
      _id: corporate._id,
    }));
    const ProductsOptions = ProductData?.map(product => ({
      value: product._id,
      label: `${product.title}`,
      _id: product._id,
    }));

    const categoryOptions = categoryData?.map(category => ({
      value: category._id,
      label:  category?.title,
      _id: category._id,
    }));

  // Function to handle the update request
  const AddUser = async () => {
    // Show loader before API call
    Swal.fire({
      title: 'Adding Product ...',
      text: 'Please wait',
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

        if (!selectedCorporate && Role === "false") {
          Swal.close(); // Close the loader before showing the error message
          Swal.fire({
            icon: "error",
            title: "Validation Error",
            text: "Please select a Corporate before proceeding.",
          });
          return; // Stop further execution
        }
  
    // Create a new FormData object
    let formData = new FormData();
    formData.append("title", Title);
    formData.append("price", Price);
    formData.append("stock", Stock);
    // formData.append("quantity", quantity);
    formData.append("length", length);
    formData.append("breadth", breadth);
    formData.append("height", height);
    formData.append("is_featured", IsFeatured);
    formData.append("description", Description);

    if(selectcategory) {
      formData.append("category_id", selectcategory);
    }
    if(selectedCorporate) {
      formData.append("corporate_id", selectedCorporate);
    };
    if(Logo) {
      formData.append("product_image", Logo);
    }
 
    try {
      // Make the API request
      let response = await axios.post(
        `${GpsBaseURL}/product`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${uniqueToken}`,
            // 'Content-Type' is automatically set by axios when using FormData
          },
        }
      );
  
      // Hide the loader
      Swal.close();
  
      // Handle the response
      if (response.data.statusCode === 200) {
        Swal.fire({
          icon: "success",
          title: "Success!",
          text: response?.data?.message,
          showConfirmButton: false,
          timer: 1500,
        });
        navigate(`/product-list`);
      } else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: `Failed to add  product. Status: ${response.data.statusCode}`,
        });
      }
    } catch (error) {
      // Hide the loader
      Swal.close();
  
      console.error("Error in AddUser:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: error.response?.data?.message || "An unexpected error occurred.",
      });
    }
  };
  const handleToggle = (e) => {
    e.preventDefault();
    setistoggle((prev) => !prev); // To state
  };
  console.log("selectedCorporate", selectedCorporate);
  console.log("productsDataaa", ProductData);
  return (
    <>
      <div className="container-fluid">
        <div className="row">
          <div className="col-sm-12">
            <div className="card">
              <h1 className="page-title"></h1>
              <div className="portlet light bordered">
                <div className="portlet-title row">
                  <div className="caption font-dark col-md-10">
                    <h4 className="caption-subject bold uppercase mx-3">
                      Add Product
                    </h4>
                  </div>
                  <div className="caption font-dark col-md-2">
                    <h5 className="caption-subject bold uppercase mx-3">
                      <button className="btn btn-success" onClick={() => navigate(-1)}>
                        Back
                      </button>
                    </h5>
                  </div>
                </div>
                <div className="portlet-body mx-3">
                  <hr />
                  <div className="row">
                    <div className="col-sm-12">
                      <form
                        className="form-horizontal"
                        encType="multipart/form-data"
                        role="form"
                        method="post"
                        style={{ marginTop: "-20px" }}
                      >
                        <div className="form-group">
                          <div className="row">
                            <label htmlFor="name_id" className="col-sm-2 control-label">
                          Title
                            </label>
                            <div className="col-sm-6">
                              <input
                                onChange={handleTitleChange}
                                value={Title}
                                className="form-control"
                                id="name_id"
                                name="station_name"
                              />
                            </div>
                            <span className="col-sm-4 control-label"></span>
                          </div>
                        </div>

                   

                        <div className="form-group">
                          <div className="row">
                            <label htmlFor="longitude_id" className="col-sm-2 control-label">
                              Enter Price
                            </label>
                            <div className="col-sm-6">
                              <input
                              type="price"
                                onChange={handlePriceChange}
                                className="form-control"
                                id="price"
                                name="price"
                                value={Price}
                              />
                            </div>
                            <span className="col-sm-4 control-label"></span>
                          </div>
                        </div>
                        <div className="form-group">
                          <div className="row">
                            <label htmlFor="longitude_id" className="col-sm-2 control-label">
                          GST
                            </label>
                            <div className="col-sm-6">
                              <input
                              type="number"
                              onChange={(e) => setGST(e.target.value)}
                                className="form-control"
                                id="stock"
                                name="stock"
                                value={GST}
                              />
                            </div>
                            <span className="col-sm-4 control-label"></span>
                          </div>
                        </div>
                        <div className="form-group">
                          <div className="row">
                            <label htmlFor="longitude_id" className="col-sm-2 control-label">
                          Stock
                            </label>
                            <div className="col-sm-6">
                              <input
                              type="number"
                              onChange={(e) => setStock(e.target.value)}
                                className="form-control"
                                id="stock"
                                name="stock"
                                value={Stock}
                              />
                            </div>
                            <span className="col-sm-4 control-label"></span>
                          </div>
                        </div>
                        <div className="form-group">
                          <div className="row">
                            <label htmlFor="longitude_id" className="col-sm-2 control-label">
                          Length
                            </label>
                            <div className="col-sm-6">
                              <input
                              type="number"
                              onChange={(e) => setlength(e.target.value)}
                                className="form-control"
                                id="stock"
                                name="stock"
                                value={length}
                              />
                            </div>
                            <span className="col-sm-4 control-label"></span>
                          </div>
                        </div>
                        <div className="form-group">
                          <div className="row">
                            <label htmlFor="longitude_id" className="col-sm-2 control-label">
                          Breadth
                            </label>
                            <div className="col-sm-6">
                              <input
                              type="number"
                              onChange={(e) => setbreadth(e.target.value)}
                                className="form-control"
                                id="stock"
                                name="stock"
                                value={breadth}
                              />
                            </div>
                            <span className="col-sm-4 control-label"></span>
                          </div>
                        </div>
                        <div className="form-group">
                          <div className="row">
                            <label htmlFor="longitude_id" className="col-sm-2 control-label">
                          Weight
                            </label>
                            <div className="col-sm-6">
                              <input
                              type="number"
                              onChange={(e) => setweight(e.target.value)}
                                className="form-control"
                                id="stock"
                                name="stock"
                                value={weight}
                              />
                            </div>
                            <span className="col-sm-4 control-label"></span>
                          </div>
                        </div>
                        <div className="form-group">
                          <div className="row">
                            <label htmlFor="longitude_id" className="col-sm-2 control-label">
                          Height
                            </label>
                            <div className="col-sm-6">
                              <input
                              type="number"
                              onChange={(e) => setheight(e.target.value)}
                                className="form-control"
                                id="stock"
                                name="stock"
                                value={height}
                              />
                            </div>
                            <span className="col-sm-4 control-label"></span>
                          </div>
                        </div>
                     
                        <div className="form-group">
                          <div className="row">
                            <label htmlFor="longitude_id" className="col-sm-2 control-label">
                          Combo
                            </label>
                            <div className="col-sm-6">
                            <button 
  onClick={handleToggle} 
  style={{
    padding: "10px 20px",
    fontSize: "16px",
    fontWeight: "bold",
    color: "white",
    border: "none",
    borderRadius: "25px",
    cursor: "pointer",
    transition: "background-color 0.3s, transform 0.2s",
    outline: "none",
    backgroundColor: istoggle ? "#28a745" : "#6c757d", // Green when ON, Gray when OFF
    boxShadow: istoggle 
      ? "0px 4px 10px rgba(40, 167, 69, 0.3)" 
      : "0px 4px 10px rgba(108, 117, 125, 0.3)",
    transform: istoggle ? "scale(1.05)" : "scale(1)"
  }}
>
  {istoggle ? "ON" : "OFF"}
</button>

                            </div>
                            <span className="col-sm-4 control-label"></span>
                          </div>
                        </div>
                        <div className="form-group">
                          <div className="row">
                            <label htmlFor="longitude_id" className="col-sm-2 control-label">
                              IsFeatured
                            </label>
                            <div className="col-sm-6">
                              <select
                              type="text"
                                onChange={handleFeaturedChange}
                                className="form-control"
                                id="text"
                                name="text"
                                value={IsFeatured}
                              
                              >
                                <option value ="">Select Option</option>
                                <option value= "Yes">Yes</option>
                                <option value= "No">No</option>
                                </select>
                            </div>
                            <span className="col-sm-4 control-label"></span>
                          </div>
                        </div>
                        <div className="form-group">
                          <div className="row">
                            <label htmlFor="longitude_id" className="col-sm-2 control-label">
                              Description
                            </label>
                            <div className="col-sm-6">
                              <textarea
                              type="text"
                                onChange={handleDescriptionChange}
                                className="form-control"
                                id=""
                                name=""
                                value={Description}
                                autoComplete="off"
                              />
                            </div>
                            <span className="col-sm-4 control-label"></span>
                          </div>
                        </div>
                        {Role==="false" && (
                        <div className="form-group">
                          <div className="row">
                            <label htmlFor="statusType" className="col-sm-2 control-label">
                              Select Corporate
                            </label>
                            <div className="col-sm-6">
                            <Select
  options={corporateOptions}
  onChange={handlecorporateChange}
  value={selectedCorporate ? corporateOptions?.find(option => option.value === selectedCorporate) : null}
  placeholder="Select Corporate"
  isClearable
  styles={{
    control: (base) => ({
      ...base,
      height: '38px', 
      width: '100%',
      boxShadow: 'none',
      minWidth: '0',
      flex: 1,
    }),
  }}
/>
                            </div>
                            <span className="col-sm-4 control-label"></span>
                          </div>
                        </div>
                       )}

{(selectedCorporate || Role === "true") && (
                      
                      <div className="form-group">
                        <div className="row">
                          <label htmlFor="statusType" className="col-sm-2 control-label">
                            Select Category
                          </label>
                          <div className="col-sm-6">
                          <Select
options={categoryOptions}
onChange={handlecategoryChange}
value={selectcategory ? categoryOptions?.find(option => option.value === selectcategory) : null}
placeholder="Select Category"
isClearable
styles={{
  control: (base) => ({
    ...base,
    height: '38px', 
    width: '100%',
    boxShadow: 'none',
    minWidth: '0',
    flex: 1,
  }),
}}
/>
                          </div>
                          <span className="col-sm-4 control-label"></span>
                        </div>
                      </div>
                      )}
                    
                      
                      
                        

                      <div className="form-group">
                          <div className="row">
                            <label htmlFor="longitude_id" className="col-sm-2 control-label">
                              Products
                            </label>
                            <div className="col-sm-6">
 <Select
  options={ProductsOptions}
  onChange={handleProductsChange}
  value={selectProduct.map(id => ProductsOptions.find(option => option.value === id))} // Ensure correct state variable
  placeholder="Select Products"
  isMulti  // ✅ Enables multiple selection
  isClearable
  styles={{
    control: (base) => ({
      ...base,
      height: 'auto', 
      width: '100%',
      boxShadow: 'none',
      minWidth: '0',
      flex: 1,
    }),
  }}
/>

                        
                            </div>
                            <span className="col-sm-4 control-label"></span>
                          </div>
                        </div>    
                       
                         <div className="form-group">
                          <div className="row">
                            <label htmlFor="longitude_id" className="col-sm-2 control-label">
                              Image
                            </label>
                            <div className="col-sm-6">
                              <input
                              type="file"
                                onChange={handleLogoChange}
                                className="form-control"
                                id=""
                                name=""
                             
                                autoComplete="off"
                              />
                            </div>
                            <span className="col-sm-4 control-label"></span>
                          </div>
                        </div>
                    
                   
                          <div className="form-group">
                          <div className="col-sm-offset-2 col-sm-8 add-class">
                            <input
                              type="button"
                              className="btn btn-success"
                              onClick={AddUser}
                              value="Add Product"
                            />
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Add;
